import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Note } from '../shared/models/note/note';
import { CreateNoteRequest, NoteType } from '../shared/models/note/create-note-request';
import { ClientNotesResponse } from '../shared/models/note/client-notes-response';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  env = environment;
  apiUrl = `${this.env.apiurl}platform/notes/`;
  //Temporarily send to the onboarding controller until we move it to a Notes controller
  onboardingUrl = `${this.env.apiurl}platform/onboarding/`;
  constructor(private http: HttpClient) {}

  public GetOnboardingClientNotes(clientId: number, isWealth: boolean = false): Observable<ClientNotesResponse> {
    const url = isWealth ? `${this.env.apiurl}platform/wealth/` : this.onboardingUrl;
    return this.http.get<ClientNotesResponse>(`${url}client/${clientId}/notes`);
  }

  public CreateClientNote(clientId: number, createdByUserId: number, note: string, isWealth: boolean = false): Observable<Note> {
    const createNoteRequest: CreateNoteRequest = {
      clientId: clientId,
      note: note,
      createdByUserId: createdByUserId,
      noteType: NoteType.Admin,
    };
    const url = isWealth ? `${this.env.apiurl}platform/wealth/` : this.onboardingUrl;
    return this.http.post<Note>(`${url}client/create-note`, createNoteRequest);
  }
}
